import React, { useState, useEffect } from 'react';
import Stories from 'react-insta-stories';
import { useParams } from 'react-router-dom';
import BasicHeader from '../../containers/basicHeader/basicHeader.js';
import Footer from '../../containers/Footer/footer';
import cookie from '../../cookieHelper/cookie'; 
import './storyPreview.scss';

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

function StoryPreview() {
  const { companyID, storyID, origin } = useParams();
  const [stories, setStories] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const windowSize = useWindowSize();

  const queryParams = new URLSearchParams(location.search);
  const publishType = queryParams.get('publishType');

  useEffect(() => {
    const API_URL1 = `${process.env.REACT_APP_BASE_URL}/api/v1/story/getByCompanyID?id=${companyID}&origin=${origin}&mediaType=mp4&prevType=story&storyID=${storyID}`;
    const API_URL2 = `${process.env.REACT_APP_BASE_URL}/api/v1/story/getReelsByCompanyID?id=${companyID}&origin=${origin}&mediaType=mp4&prevType=story&storyID=${storyID}`;
    const API_URL = publishType === "2" ? API_URL2 : API_URL1;

    // Get the token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);


    setIsLoading(true);

    fetch(API_URL, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch stories');
        }
        return response.json();
      })
      .then(data => {
        if (data.status && data.status.code === "10200" && data.data[0].storiesList) {
          let storiesData = data.data[0].storiesList.reverse();

          let newStoriesData = storiesData.filter(story => Object.keys(story).length > 0);

          const index = newStoriesData.findIndex(story => story.storyId === storyID);

          const formattedStories = newStoriesData.map(story => ({
            url: story.s3Path,
            type: story.s3Path.endsWith('.mp4') ? 'video' : 'image',
            header: {
              heading: data.data[0].companyName,
              profileImage: data.data[0].companiesLogo,
            },
            duration: story.s3Path.endsWith('.mp4') ? 10000 : 5000,
          }));

          setStories(formattedStories);
          setCurrentIndex(index !== -1 ? index : -1);
        } else {
          throw new Error('Failed to fetch stories');
        }
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error fetching stories:', error);
        setError(error);
        setIsLoading(false);
      });
  }, [companyID, storyID, origin, publishType]);

  const handleStoryEnd = (index, story) => {
    if (stories.length === 1) {
      setCurrentIndex(0);
    } else if (index === stories.length - 1) {
      setCurrentIndex(0);
    } else {
      setCurrentIndex(index + 1);
    }
  };

  const width = windowSize.width < 432 ? windowSize.width : 432;
  const height = windowSize.width < 432 ? (windowSize.width / 432) * 768 : 768;

  return (
    <div>
      <BasicHeader />
      <div className="story-container">
        {isLoading ? (
          <div className="loading"></div>
        ) : error ? (
          <div className="no-active-story">
            No Story Found.
          </div>
        ) : (
          <>
            {currentIndex !== -1 && stories && stories.length > 0 ? (
              <div className="content">
                <Stories
                  stories={stories}
                  defaultInterval={1500}
                  width={width}
                  height={height}
                  currentIndex={currentIndex}
                  onStoryEnd={handleStoryEnd}
                  autoplay={true}
                  mute={false}
                />
              </div>
            ) : (
              <div className="no-active-story">
                No Story Found.
              </div>
            )}
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default StoryPreview;
